// extracted by mini-css-extract-plugin
export var aircallIframe = "_g6-3";
export var fabContainer = "_g6-5";
export var fabRinging = "_g6-6";
export var loadingOverlay = "_g6-4";
export var pulse = "_g6-7";
export var widgetContent = "_g6-2";
export var widgetPanel = "_g6-0";
export var widgetPanelExpanded = "_g6-1";